'use client';
import { useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';

import { Url } from '../../../route/router';

import { navigateFullPage } from '../../../utils/router';

import { showWarningToast } from '@vs-shop/ui/toast';

import type { AuthSessionStatus } from '../../../effect/atom/auth/auth';
import { authSessionStatusAtom } from '../../../effect/atom/auth/auth';
import { removeAuthTokenAtomFn } from '@vs-shop/engine/atom/auth/mutation/removeAuthToken';
import { tokenRefreshAtom } from '../../../effect/atom/auth/tokenRefresh';
import * as AsyncResult from 'effect/unstable/reactivity/AsyncResult';
import { useAtomSet, useAtomValue } from '@effect/atom-react';

export default function TokenRefreshInterval() {
  const intl = useIntl();

  useAtomValue(tokenRefreshAtom);

  const sessionStatusResult = useAtomValue(authSessionStatusAtom);
  const removeAuthToken = useAtomSet(removeAuthTokenAtomFn, { mode: 'promiseExit' });
  const hasHandledExpiry = useRef(false);

  const sessionStatus = AsyncResult.match(sessionStatusResult, {
    onInitial: (): AuthSessionStatus => 'anonymous',
    onFailure: (): AuthSessionStatus => 'anonymous',
    onSuccess: (s): AuthSessionStatus => s.value,
  });

  useEffect(() => {
    if (sessionStatus === 'sessionExpired' && !hasHandledExpiry.current) {
      hasHandledExpiry.current = true;

      showWarningToast(
        intl.formatMessage({
          id: 'auth.session.expired',
          defaultMessage: 'Vaše relace vypršela, přihlaste se prosím znovu.',
        })
      );

      void removeAuthToken().then(() => {
        navigateFullPage(Url.account);
      });
    }

    if (sessionStatus !== 'sessionExpired') {
      hasHandledExpiry.current = false;
    }
  }, [sessionStatus, intl, removeAuthToken]);

  return null;
}
